import { Beer, CalendarCheck, Car, Dices, Martini, Music, PawPrint, Star, Trees } from "lucide-react";
import business from "../data/business.json";
import { Reveal } from "./Reveal";

const ICONS = {
    trees: Trees,
    music: Music,
    beer: Beer,
    martini: Martini,
    dices: Dices,
    paw: PawPrint,
    car: Car,
    calendar: CalendarCheck,
};

export const QuickFacts = () => (
    <section aria-label="Il River Pub in breve" className="border-b border-bordo bg-carbone">
        <div className="container-pub py-10">
            <Reveal className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-6" data-testid="quick-facts">
                {business.quickFacts.map((f) => {
                    const Icon = ICONS[f.icon] || Star;
                    return (
                        <div key={f.label} className="flex items-center gap-3" data-testid="quick-fact-item">
                            <Icon className="w-5 h-5 text-ambra shrink-0" strokeWidth={1.5} />
                            <span className="text-[15px] text-avorio/90">{f.label}</span>
                        </div>
                    );
                })}
            </Reveal>
        </div>
    </section>
);